import { render, staticRenderFns } from "./Oauth2Callback.vue?vue&type=template&id=70dc60e2&scoped=true"
import script from "./Oauth2Callback.vue?vue&type=script&lang=js"
export * from "./Oauth2Callback.vue?vue&type=script&lang=js"
import style0 from "./Oauth2Callback.vue?vue&type=style&index=0&id=70dc60e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc60e2",
  null
  
)

export default component.exports